export class ApiResult {
  public statusId: number = 0;
  public code: number = 0;
  public message: string = '';

  public get IsSuccess() : boolean {
    return this.statusId == 200;
  }
  tryParse(result: any) {
    try {
      if (result == null) {
        this.code = 0;
        this.statusId = 0;
        this.message = 'Fatal error.';
      } else if (typeof result === 'string') {
        const parsedResult = JSON.parse(result);
        this.code = parsedResult.code;
        this.statusId = parsedResult.statusId;
        this.message = parsedResult.message;
      } else if (result.statusId != null) {
        this.code = result.code;
        this.statusId = result.statusId;
        this.message = result.message;
      } else if (result.error != null) {
        this.code = result.error.code;
        this.statusId = result.error.statusId;
        this.message = result.error.message;
      } else if (result.status != null) {
        this.code = 0;
        this.statusId = result.status;
        result.message = result.statusText;
      }
    } catch (e) {
      this.statusId = 501;
      this.code = 0;
      this.message = 'Wystąpił nieoczekiwany błąd. Spróbuj ponownie później';
      return false;
    }
    if (this.statusId == null) {
      this.statusId = 500;
      this.code = 0;
      this.message = 'Wystąpił nieoczekiwany błąd. Spróbuj ponownie później.';
      return false;
    }
    return true;
  }
  constructor(result: any) {
    this.tryParse(result);
  }
}
